<template lang="pug">
  .component-inline-editable-field(title="Double click for edit")
    .fa.fa-save(v-if="editable", @click="saveAndClose") &nbsp;
    .fa.fa-times(v-if="editable", @click="closeAndRevert")
    .field(:contenteditable="editable", @dblclick="toggleEdit", :class="{editable:editable}", @input="update", @keyup.enter="update") {{ item_field }}

</template>

<script>
  export default {
    name: "InlineEditableField",
    props: ['item'],
    data() {
      return {
        item_field: this.item,
        editable: false
      }
    },
    created() {
      this.test = this.item
    },
    methods: {
      update: function (event) {

        if (event.which === 13) {
          var elt = event.target;
          elt.innerText = elt.innerText.replace(/\n/g, ' ');
          event.preventDefault();
          this.saveAndClose()
          return
        }

        this.item_field = event.target.textContent;
        var range, selection;

        // move the cursor to the end of the editable content
        if (document.createRange) {
          range = document.createRange();//Create a range (a range is a like the selection but invisible)
          range.selectNodeContents(event.target);//Select the entire contents of the element with the range
          range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
          selection = window.getSelection();//get the selection object (allows you to change selection)
          selection.removeAllRanges();//remove any selections already made
          selection.addRange(range);//make the range you have just created the visible selection
        } else if (document.selection) {
          range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
          range.moveToElementText(event.target);//Select the entire contents of the element with the range
          range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
          range.select();//Select the range (make it the visible selection
        }
      },
      toggleEdit() {
        this.editable = true
      },
      saveAndClose() {
        this.editable = false
        this.$emit('fieldUpdated', this.item_field)
      },
      closeAndRevert() {
        this.item_field = this.item
        this.editable = false
      }
    }
  }
</script>

<style scoped lang="sass" rel="stylesheet/sass">
  .field
    text-decoration: underline
    border: 1px dotted
    &.editable
      background: white
      padding: 5px
</style>



// WEBPACK FOOTER //
// InlineEditableField.vue?acba26ce